import useSWR from "swr";
export const useProofOfRegistrationList = (companyId) => useSWR(companyId ? `proofOfRegistration/${companyId}` : null);
